import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import SpecterLogo from "../../images/specter-logo-light.png";
import CstQr from "../../images/cstQr.png";
import AppStoreIcon from "../../images/icons/app-store-light.svg";
import GooglePlayIcon from "../../images/icons/google-play-light.svg";

const Footer = () => {
  const { t, i18n } = useTranslation();

  const switchLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    if (lng === "ar") {
      document.documentElement.dir = "rtl";
    } else {
      document.documentElement.dir = "ltr";
    }
  };

  useEffect(() => {
    if (i18n.language === "ar") {
      document.documentElement.dir = "rtl";
    } else {
      document.documentElement.dir = "ltr";
    }
  }, [i18n.language]);

  return (
    <section id="footer" className="bg-main text-white">
      <div className="container relative mx-auto flex flex-col justify-center items-center gap-14 px-4">
        <div className="w-full grid grid-cols-1 md:grid-cols-5 gap-10 md:gap-0 pt-40 pb-10">
          <div className="flex flex-col justify-between items-center gap-8">
            <a href="#home">
              <img src={SpecterLogo} className="w-fit" alt="Specter" />
            </a>
            <div className="flex flex-col items-center justify-start gap-4 text-center">
              <p className="flex flex-col text-sm gap-1">
                {t("footer.tax_number")} <span>310140808100003</span>
              </p>
              <div className="flex flex-col text-sm gap-1">
                <p>{t("footer.commercial_registration")}</p>
                <span>4030587962</span>
              </div>
              <div className="flex flex-col text-sm gap-2 items-center">
                <p>{t("footer.authority")}</p>
                <img
                  src={CstQr}
                  alt="CST QR"
                  className="w-20 h-20 inline-block"
                />
              </div>
            </div>
          </div>
          <ul className="space-y-5 h-full flex flex-col items-center justify-start">
            <li className="text-lg font-bold mb-6">
              {t("footer.quick_access")}
            </li>
            <li>
              <a href="#home">{t("footer.home")}</a>
            </li>
            <li>
              <a href="#features">{t("footer.features")}</a>
            </li>
            <li>
              <a href="#why-us">{t("footer.why_us")}</a>
            </li>
          </ul>
          <ul className="space-y-5 flex flex-col items-center justify-start">
            <li className="text-lg font-bold mb-6">
              <p>{t("footer.important_links")}</p>
            </li>
            <li>
              <a href="#plans">{t("footer.services")}</a>
            </li>
            <li>
              <a href="#footer">{t("footer.contact_us")}</a>
            </li>
            <li>
              <div
                key={i18n.language}
                className="cursor-pointer capitalize"
                onClick={() =>
                  switchLanguage(i18n.language === "en" ? "ar" : "en")
                }
              >
                {t("footer.lang")}
              </div>
            </li>
          </ul>
          <ul className="space-y-5 flex flex-col items-center justify-start">
            <li className="text-lg font-bold mb-6">
              <p>{t("footer.contact_us")}</p>
            </li>
            <li>
              <a href={"tel:" + t("footer.phone_1")}>{t("footer.phone_1")}</a>
            </li>
            <li>
              <a href={"tel:" + t("footer.phone_2")}>{t("footer.phone_2")}</a>
            </li>
            <li>
              <a href={"tel:" + t("footer.phone_3")}>{t("footer.phone_3")}</a>
            </li>
            <li>
              <a href={"tel:" + t("footer.phone_4")}>{t("footer.phone_4")}</a>
            </li>
            <li>
              <a href={"mailto:" + t("footer.mail")}>{t("footer.mail")}</a>
            </li>
          </ul>
          <div className="flex flex-col items-center justify-start">
            <p className="text-lg text-nowrap font-bold">
              {t("footer.download_app")}
            </p>
            <div className="mt-10 flex flex-col items-center gap-3 md:gap-4">
              <a
                href="https://apps.apple.com/us/app/specter-app/id1667869308"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src={AppStoreIcon}
                  alt="App Store"
                  className="w-full inline-block cursor-pointer hover:scale-105 transition-all duration-500"
                />
              </a>
              <a href="/" target="_blank" rel="noreferrer">
                <img
                  src={GooglePlayIcon}
                  alt="Google Play"
                  className="w-full inline-block cursor-pointer hover:scale-105 transition-all duration-500"
                />
              </a>
            </div>
          </div>
        </div>

        <div dir="ltr" className="w-full text-center py-5 border-t">
          {t("footer.copyright")}
        </div>
      </div>
    </section>
  );
};

export default Footer;
